import i18n from '@/plugins/i18n'

export default [
    {
        path: '/' + i18n.t('routes.contact.index'),
        name: 'contact.index',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "contacts" */ '@/views/contacts/Index.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.contact.breadcrumb.index'),
                    disable: true,
                },
            ],
            showName: 'Contatos',
        },
    },
    {
        path: '/' + i18n.t('routes.contact.create'),
        name: 'contact.create',
        child: true,
        component: () =>
            import(
                /* webpackChunkName: "contacts" */ '@/views/contacts/Create.vue'
            ),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.contact.breadcrumb.index'),
                    to: { name: 'contact.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.contact.breadcrumb.create'),
                    disable: true,
                },
            ],
        },
    },
    {
        path: '/' + i18n.t('routes.contact.edit') + '/:id',
        name: 'contact.edit',
        child: true,
        component: () => import('@/views/contacts/Edit.vue'),
        meta: {
            requiresAuth: true,
            breadcrumb: [
                {
                    text: i18n.t('routes.contact.breadcrumb.index'),
                    to: { name: 'contact.index' },
                    disable: false,
                },
                {
                    text: i18n.t('routes.contact.breadcrumb.edit'),
                    disable: true,
                },
            ],
        },
        props: true,
    },
]
